import { useContext } from 'react'
import { formatBigInt, Style } from '../../common/format_large_number'
import { GameContext } from '../../App'
import useDebtCalculation from '../../hooks/useDebtCalculation'

export default function DebtCounter() {
	const gameContext = useContext(GameContext)
	if (!gameContext) throw new Error('No GameContext')

	const { debt, debtPerSecond } = useDebtCalculation()

	return (
		<div className="text-center">
			<h2 className="mb-2 text-2xl font-bold text-purple-100">
				Campaign Balance
			</h2>
			<div className="mb-4">
				<span className="text-4xl font-bold text-purple-50">
					${formatBigInt(debt, Style.Long)}
				</span>
			</div>
			<div className="flex justify-between text-purple-200">
				<div>
					<p className="text-sm">Per Second</p>
					<p className="text-xl font-semibold">
						-{formatBigInt(debtPerSecond, Style.Short)}
					</p>
				</div>
				<div>
					<p className="text-sm">Prestige Level</p>
					<p className="text-xl font-semibold">
						{gameContext.currentPrestigeLevels ?? 0}
					</p>
				</div>
			</div>
		</div>
	)
}
